// src/context/CartContext.js
import React, { createContext, useEffect, useState } from "react"

export const CartContext = createContext()

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([])

  useEffect(() => {
    const handleSnipcartReady = () => {
      if (!window.Snipcart) return

      const updateCartData = () => {
        const cart = window.Snipcart.store.getState().cart.items.items
        setCartItems([...cart])
        console.log("🛒 Carrito actualizado:", cart)
      }

      window.Snipcart.events.on("item.added", updateCartData)
      window.Snipcart.events.on("item.removed", updateCartData)
      window.Snipcart.events.on("item.updated", updateCartData)

      updateCartData()
    }

    document.addEventListener("snipcart.ready", handleSnipcartReady)

    return () => {
      document.removeEventListener("snipcart.ready", handleSnipcartReady)
    }
  }, [])

  return (
    <CartContext.Provider value={{ cartItems }}>
      {children}
    </CartContext.Provider>
  )
}
